import React, { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import OperationalTable from '../../../../organisms/OperationalTable'
import Card from '../../../../molecules/Card'

const sourceColumns = [
  { id: 'namespace', accessor: 'namespace', Header: 'Namespace' },
  { id: 'domain', accessor: 'domain', Header: 'Domain' },
  { id: 'sourceKey', accessor: 'sourceKey', Header: 'Source Key' },
  { id: 'label', accessor: 'label', Header: 'Label' }
]
const defaultSort = [{
  id: 'sourceKey', desc: false
}]

function IntegrationSourceList ({ root, connectionId, sources }) {
  const connectionSources = useMemo(() => {
    return (sources || []).filter(x => x.connectionId === connectionId)
  }, [connectionId, sources])

  const history = useHistory()
  const onRowClick = useCallback((row) => {
    if (!row.original?.integrationSourceId) return
    history.push(`${root}/integrator/sources/${row.original.integrationSourceId}`)
  }, [history, root])

  return (
    <Card className='flex flex-col gap-sm'>
      <div className='flex items-center flex-wrap justify-between'>
        <div className='flex flex-1 gap-sm font-size-md font-bold items-center'>
          Integration sources
          <span
            className='font-size-xs font-medium text-neutral-500 bg-neutral-200 radius-lg px-2'
          >
            {connectionSources.length}
          </span>
        </div>
        <div className='font-size-xs text-neutral-500'>Available sources for this connection</div>
      </div>
      <div style={{ overflow: 'auto' }}>
        <OperationalTable
          variant='v2'
          data={connectionSources}
          columns={sourceColumns}
          options={connectionSources}
          onRowClick={onRowClick}
          defaultSort={defaultSort}
          hideFooter
        />
      </div>
    </Card>
  )
}

IntegrationSourceList.propTypes = {
  connectionId: PropTypes.number,
  sources: PropTypes.arrayOf(PropTypes.shape({
    sourceKey: PropTypes.string,
    domain: PropTypes.string,
    label: PropTypes.string
  })),
  root: PropTypes.string
}

export default IntegrationSourceList
